import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WEEE_FEEDBACK_FEATURE_NAME } from '~shared/modules/weee-landing-page/store/feature-name';
import { WeeeFeedbackState } from '~shared/modules/weee-landing-page/store/weee-feedback';

export const getWeeeFeedbackState = createFeatureSelector<WeeeFeedbackState>(WEEE_FEEDBACK_FEATURE_NAME);

export const getWeeeFeedbackStatus =
  createSelector(getWeeeFeedbackState, (state: WeeeFeedbackState) => (state && state.status)
  );

export const getIsLoading =
  createSelector(getWeeeFeedbackState, (state: WeeeFeedbackState) => (state && state.isLoading));


